/* Bandeau des sous-collections (snippets/sdp-subcollection-strip.liquid).
   Flèches de défilement et bascule « Tout voir » / « Réduire ». Sans JS, le
   bandeau reste défilable au doigt ou au trackpad. */
(function () {
  function init(strip) {
    var track = strip.querySelector('[data-sdp-cs-track]');
    var prev = strip.querySelector('[data-sdp-cs-prev]');
    var next = strip.querySelector('[data-sdp-cs-next]');
    var toggle = strip.querySelector('[data-sdp-cs-toggle]');
    if (!track) return;

    function update() {
      var expanded = strip.classList.contains('is-expanded');
      var overflow = track.scrollWidth > track.clientWidth + 1;
      // Tolérance d'un pixel : les largeurs fractionnaires laissent un reste.
      prev.hidden = expanded || !overflow || track.scrollLeft <= 1;
      next.hidden = expanded || !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      toggle.hidden = !expanded && !overflow;
    }

    function scroll(direction) {
      track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scroll(-1); });
    next.addEventListener('click', function () { scroll(1); });
    toggle.addEventListener('click', function () {
      var expanded = strip.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded);
      toggle.querySelector('[data-sdp-cs-more]').hidden = expanded;
      toggle.querySelector('[data-sdp-cs-less]').hidden = !expanded;
      if (!expanded) {
        track.scrollLeft = 0;
        strip.scrollIntoView({ block: 'nearest' });
      }
      update();
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-sdp-cs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
